<style lang="stylus">
    html.dark
        .aiFeedback .aiFeedback-content
            background-image url('../../assets/img/ai4/feedback-dark.png')
    .aiFeedback
        position fixed
        left 0
        top 0
        width 100%
        height 100%
        display flex
        justify-content center
        align-items center
        z-index 10
        .aiFeedback-content
            width 304px
            padding-bottom 20px
            border-radius 8px
            background-image url('../../assets/img/ai4/feedback.png')
            background-repeat no-repeat
            background-size cover;
            box-shadow $modal-shadow
            .aiFeedback-header
                height 40px
                padding 0 8px 0 12px
                display flex
                align-items center
                user-select none

                .header-icon
                    width 16px
                    height 16px
                    margin-right 4px
                    img
                        width 16px
                        height 16px
                .header-text
                    font-size 12px
                    color var(--text-color-primary)

                .header-close
                    display flex
                    align-items center
                    justify-content center
                    width 24px
                    height 24px
                    margin-left auto
                    cursor pointer
                    border-radius 6px

                    &:hover
                        background var(--bg-color-dialog-close-hover)

                    svg
                        width 16px
                        height 16px
                        stroke var(--svg-color-gray-42)
            .aiFeedback-box
                margin 18px 24px 0 24px
                .aiFeedback-title
                    display flex
                    align-items center
                    justify-content center
                    margin-bottom 12px
                    img
                        display block
                        width 24px
                        height 24px
                        margin-right 8px
                    p
                        font-size 16px
                        line-height 20px
                        color var(--text-color-primary)
                        font-weight 600
                .aiFeedback-subtitle
                    color var(--text-color-primary)
                    font-size 12px
                    line-height 16px
                    margin-bottom 16px
                .aiFeedback-inputbox
                    width 100%
                    height 112px
                    padding 12px
                    padding-right 0
                    background var(--bg-color-ai-feedback-inputbox)
                    margin-bottom 24px
                    border-radius 6px
                    .aiFeedback-input
                        width 100%
                        height 64px
                        padding-right 12px
                        outline none
                        resize none
                        border none
                        outline none
                        background none
                        line-height 16px
                        &::placeholder
                            color var(--text-color-tertiary)
                    .aiFeedback-inputcount
                        margin-top 4px
                        padding-right 12px
                        width 100%
                        text-align right
                        font-size 12px
                        color var(--text-color-tertiary)
            .aiFeedback-btnbox
                width 100%
                padding 0 24px
                display flex
                justify-content flex-end
                .aiFeedback-btn
                    height 28px
                    blueBtn()
</style>

<template>
    <div class="aiFeedback">
        <div class="aiFeedback-content">
            <div class="aiFeedback-header">
                <div class="header-icon">
                    <img src="@/app/assets/img/ai4/ai-chat-icon-sdk.svg" v-if="EDCONFIG.IS_SDK" />
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                        <g clip-path="url(#clip0_11412_26856)">
                            <rect width="16" height="16" fill="url(#paint0_linear_11412_26856)" />
                            <path
                                d="M7.99999 8.8125H4.75C4.30127 8.8125 3.9375 8.44873 3.9375 8C3.9375 7.55127 4.30127 7.1875 4.75 7.1875H7.99999C8.44872 7.1875 8.81249 7.55127 8.81249 8C8.81249 8.44873 8.44872 8.8125 7.99999 8.8125Z"
                                fill="white"
                                fill-opacity="0.6"
                            />
                            <path
                                d="M7.99999 4.75H4.75C4.30127 4.75 3.9375 4.38623 3.9375 3.9375C3.9375 3.48877 4.30127 3.125 4.75 3.125H7.99999C10.6924 3.125 12.875 5.30761 12.875 7.99999C12.875 10.6924 10.6924 12.875 7.99999 12.875H4.75C4.30127 12.875 3.9375 12.5112 3.9375 12.0625C3.9375 11.6137 4.30127 11.25 4.75 11.25H7.99999C9.79491 11.25 11.25 9.79491 11.25 7.99999C11.25 6.20507 9.79491 4.75 7.99999 4.75Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <linearGradient
                                id="paint0_linear_11412_26856"
                                x1="16.7272"
                                y1="18.6666"
                                x2="1.16582"
                                y2="-3.96816"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#0066FF" />
                                <stop offset="1" stop-color="#66CCFF" />
                            </linearGradient>
                            <clipPath id="clip0_11412_26856">
                                <rect width="16" height="16" rx="3.65049" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <span class="header-text">{{ EDCONFIG.IS_SDK ? $t("titleDark") : $t("title") }}</span>
                <div class="header-close" @click="close()">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3L13 13" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3 13L13 3" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>

            <div class="aiFeedback-box">
                <div class="aiFeedback-title">
                    <img src="@/app/assets/img/ai3/face.png" alt="" />
                    <p>{{ $t("mainTitle") }}</p>
                </div>
                <p class="aiFeedback-subtitle">
                    {{ $t("subTitle") }}
                </p>

                <div class="aiFeedback-inputbox">
                    <textarea v-model="inputStr" class="aiFeedback-input" maxlength="1000" :placeholder="$t('placeholder')"></textarea>
                    <p class="aiFeedback-inputcount">{{ `${inputStr.length}/1000` }}</p>
                </div>
            </div>

            <div class="aiFeedback-btnbox">
                <div class="aiFeedback-btn" @click="confirm">{{ $t("confirm") }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class AiFeedback extends Vue {
        inputStr = "";
        close() {
            this.$bus.$emit("closeFeedback");
        }
        confirm() {
            this.$emit("confirmFeedback", this.inputStr);
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "title": "亿图图示",
        "mainTitle": "很抱歉没能让您满意",
        "subTitle": "我们很重视用户体验，欢迎您在下方写下意见或建议，方便我们改进（非必填）",
        "placeholder": "请在此填写意见或建议",
        "confirm": "提交反馈"
    },
    "en": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "We are sorry to hear that you're unsatisfied.",
        "subTitle": "We take user experience seriously. Please leave any feedback or suggestions you may have so we can improve. (optional)",
        "placeholder": "Please leave your feedback or suggestions here",
        "confirm": "Submit feedback"
    },
    "fr": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "Nous sommes désolés d'apprendre que vous n'êtes pas satisfait.",
        "subTitle": "Nous prenons l'expérience utilisateur très au sérieux. Faites-nous part de vos commentaires ou de vos suggestions afin que nous puissions nous améliorer. (facultatif)",
        "placeholder": "Laissez vos commentaires ou vos suggestions ici",
        "confirm": "Envoyer le commentaire"
    },
    "de": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "Wir bedauern, dass Sie unzufrieden sind.",
        "subTitle": "Wir legen Wert auf das Benutzererlebnis. Wir freuen uns über Feedback und Vorschläge, damit wir uns verbessern können. (optional)",
        "placeholder": "Hier können Sie Feedback oder Vorschläge einreichen",
        "confirm": "Feedback absenden"
    },
    "jp": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "ご満足いただけず残念です。",
        "subTitle": "当社は、ユーザーエクスペリエンスを大切にしています。改善のためのご意見・ご提案がございましたら、ご記入ください。（任意）",
        "placeholder": "ご意見・ご提案をこちらにご記入ください",
        "confirm": "フィードバックを送信"
    },
    "es": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "Lamentamos no haber podido satisfacer tus necesidades.",
        "subTitle": "Nos tomamos muy en serio la experiencia del usuario. Envíanos cualquier comentario o sugerencia que puedas tener para que podamos mejorar. (Opcional)",
        "placeholder": "Introduce aquí tus comentarios o sugerencias",
        "confirm": "Enviar comentarios"
    },
    "pt": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "É uma pena saber que você não gostou.",
        "subTitle": "Levamos a experiência do usuário a sério. Deixe seu feedback ou sugestões para que possamos melhorar. (opcional)",
        "placeholder": "Deixe seu feedback ou sugestões aqui",
        "confirm": "Enviar feedback"
    },
    "it": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "Siamo spiacenti di sapere che non sei soddisfatto.",
        "subTitle": "Abbiamo a cuore l'esperienza degli utenti. Lascia un feedback o dei suggerimenti che possono permetterci di migliorare. (facoltativo)",
        "placeholder": "Lascia qui feedback o suggerimenti",
        "confirm": "Invia feedback"
    },
    "tw": {
        "title": "EdrawMax",
        "titleDark": "Edraw AI",
        "mainTitle": "未讓您感到滿意，我們深感遺憾。",
        "subTitle": "我們非常重視使用者體驗。請留下您的任何意見反應或建議，以便我們改進。(選填)",
        "placeholder": "請在此留下您的意見反應或建議",
        "confirm": "提交意見反應"
    }
}
</i18n>
